import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { FormGroup, ControlLabel } from 'react-bootstrap'
import { Row, Col } from 'react-flexbox-grid'

import { mapToSelectArray } from 'Shared/helpers'
import { GlgSelect } from 'SharedComponents'

class CategoryFilter extends Component {
  constructor(props) {
    super(props)
    this.onChange = props.onChange.bind(this, 'category')
  }

  shouldComponentUpdate(nextProps) {
    // We need to check the categories content because of the possible category name change
    return this.props.categoriesOptions.length !== nextProps.categoriesOptions.length ||
           this.props.value !== nextProps.value ||
           this.props.disabled !== nextProps.disabled ||
           !_.isEqual(this.props.categoriesOptions, nextProps.categoriesOptions)
  }

  render() {
    const categoriesSelectOptions = mapToSelectArray(this.props.categoriesOptions, { changeNone: false })
    const categoryText = (!window.I18n ? '' : window.I18n.t('customer_center_filters.components.filters.category_filter.category'))
    return <FormGroup><Row><Col xs={true}><ControlLabel className="add-margin-top-5">{categoryText}</ControlLabel></Col></Row><Row><Col xs={true}><GlgSelect items={ categoriesSelectOptions } value={ this.props.value } onChange={ this.onChange } disabled={ this.props.disabled } isCustomized={ this.props.isCustomized }></GlgSelect></Col></Row></FormGroup>
  }
}

CategoryFilter.propTypes = {
  categoriesOptions: PropTypes.array.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  isCustomized: PropTypes.bool,
}

export default CategoryFilter
